
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import VWrapper from '@/components/shared/VWrapper.vue';
import HealthCheckTable from '@/components/healthCheck/HealthCheckTable.vue';
import { namespace } from 'vuex-class';
import Filter from '@/interfaces/api/Filter';
import { HealthCheck as HealthCheckModel } from '@/interfaces/models/HealthCheck';
import { Venue } from '@/interfaces/models/Venue';
import CustomerGroup from '@/mixins/CustomerGroup';

const healthCheck = namespace('healthCheck');
const venue = namespace('venue');
const app = namespace('app');

@Component({
  components: { VWrapper, HealthCheckTable },
})
export default class HealthCheck extends mixins(CustomerGroup) {
  @healthCheck.Action('setFilter') public setFilter!: (filter: Filter) => void;
  @healthCheck.Action('fetch') public getItems!: any;
  @healthCheck.Action('delete') public deleteHealthCheck!: any;

  @healthCheck.State((state) => state.pagination.total) public total!: number;
  @healthCheck.State('filter') public filter!: Filter;
  @healthCheck.State('items') public items!: [];
  @venue.State('active') public venue!: Venue;
  @app.State('venues') public venues!: Venue[];

  public async mounted() {
    if (!this.filter?.customerGroup) {
      return;
    }

    this.$startLoading('healthChecks');
    await this.getItems({ page: 1 });
    this.$stopLoading('healthChecks');
  }

  public async onFilter(val: object) {
    this.$startLoading('healthChecks');
    this.setFilter(val);
    await this.getItems({ page: 1 });
    this.$stopLoading('healthChecks');
  }

  public async remove(healthCheck: HealthCheckModel) {
    this.$startLoading('healthChecks');
    await this.deleteHealthCheck({ id: healthCheck._id });
    this.$stopLoading('healthChecks');
  }

  public edit(item: HealthCheckModel) {
    this.$router.push({
      name: 'healthCheck.edit',
      params: { id: item._id },
      query: { ...this.$route.query },
    });
  }
}
